import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-admin-portal-root',
  templateUrl: './admin-portal-root.component.html',
  styleUrls: ['./admin-portal-root.component.css']
})
export class AdminPortalRootComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
